export type TLMSBlueprint = {
  label: string
  id: string
}

export function castAsTuple<T>(value: unknown): [T, T] {
  if (!value) return [undefined, undefined] as [T, T]
  return value as [T, T]
}
